import {TransactionColKey} from "../../../enums/TransactionColKey";
import {StorageKey} from "../../../enums/StorageKey";
import {withTransactionColumnInfo} from "../../Table/Transaction/withTransactionColumnInfo";
import {transactionColumnSortable} from "../../Table/Transaction/getTransactionColumnSortable";
import {t} from "@lingui/macro";

const columns = [
    { key: TransactionColKey.number },
    { key: TransactionColKey.date },
    { key: TransactionColKey.contact_name, title: t`Customer` },
    { key: TransactionColKey.billing_party },
    { key: TransactionColKey.shipping_info },
    { key: TransactionColKey.shipping_party },
    { key: TransactionColKey.number2 },
    { key: TransactionColKey.title },
    { key: TransactionColKey.description },
    { key: TransactionColKey.tag_names },
    { key: TransactionColKey.amount },
    { key: TransactionColKey.status },
    { key: TransactionColKey.email },
    { key: TransactionColKey.custom_fields }, // multi-columns
    { key: TransactionColKey.transfer },
    { key: TransactionColKey.files },
    { key: TransactionColKey.created_at },
    { key: TransactionColKey.created_by },
    { key: TransactionColKey.action },
];

export default {
    storageKey: StorageKey.sale_order,
    required: [
        TransactionColKey.number,
        TransactionColKey.action,
    ],
    defaulto: [
        TransactionColKey.date,
        TransactionColKey.contact_name,
        TransactionColKey.amount,
        TransactionColKey.status,
        TransactionColKey.email,
        TransactionColKey.transfer,
        TransactionColKey.files,
    ],
    sortable: transactionColumnSortable,
    getColumns: (props, fields) => withTransactionColumnInfo(columns, props, fields),
};
